import React from "react";
import { ReactComponent as PlusIcon } from "../../../assets/icons/add_black_24dp.svg";
import { ReactComponent as MinusIcon } from "../../../assets/icons/remove_black_24dp.svg";

const TickerButton = ({ onClick, direction, disabled }) => {
  return (
    <div
      className={`ticker-button${disabled ? " ticker-button--disabled" : ""}`}
      onClick={disabled ? undefined : onClick}
    >
      {direction === "up" ? (
        <PlusIcon className="ticker-button__icon" />
      ) : (
        <MinusIcon className="ticker-button__icon" />
      )}
    </div>
  );
};

export default TickerButton;
